import ActivityLogService from '@/services/activity-logs/activity-log-service'

export const state = {
  activities: [],
  loading: false
}

export const getters = {
  activities: state => state.activities,
  loading: state => state.loading
}

export const actions = {
  fetchDashboardActivityLogs({ commit }) {
    commit('SET_LOADING', true)

    ActivityLogService.dashboardActivityLogs()
      .then(response => {
        commit('SET_ACTIVITIES', response.data)
      })
      .catch(() => {
        commit('SET_ACTIVITIES', [])
      })
      .then(() => {
        commit('SET_LOADING', false)
      })
  },

  fetchProjectActivityLogs({ commit }, project_id) {
    commit('SET_LOADING', true)

    ActivityLogService.projectActivityLogs(project_id)
      .then(response => {
        commit('SET_ACTIVITIES', response.data)
      })
      .catch(() => {
        commit('SET_ACTIVITIES', [])
      })
      .then(() => {
        commit('SET_LOADING', false)
      })
  }
}

export const mutations = {
  SET_ACTIVITIES(state, activities) {
    state.activities = activities
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  }
}
